// NOTE: This should be a noop for all brands EXCEPT TH. We only need this code
// for a short time in order to redirect US users stuck on the TH CA native experience.
// SEE: https://rbictg.atlassian.net/browse/SHOP-2103

const useLoyaltyRedirect = () => {};

export default useLoyaltyRedirect;
